import uniqueID from 'lodash/uniqueId';

import { USE_PARITY } from '../constants';

export const makeEbonName = ({ vendorName, facialValue }) =>
    `Bon d'achat ${vendorName} - ${facialValue}€`;

export const createEbon = ({
    id,
    quantityAvailable = 1,
    facialValue,
    vendorName,
    expirationDate = null,
    sellingPrice = 0
}) => ({
    id: id || `artificial-id#${uniqueID()}`,
    value: facialValue,
    name: makeEbonName({ vendorName, facialValue }),
    stock: quantityAvailable,
    expirationDate,
    sellingPrice
});

export const exportEbon = partnerId => ({ amount: quantityQuery, value: facialValue }) => ({
    facialValue,
    quantityQuery,
    partnerId
});

export const ebonSellingPriceTotal = (acc, { sellingPrice }) => acc + sellingPrice;

export const compareEbons = (a, b) => a.value - b.value;

export const queryEqualLocked = element =>
    element && element.quantityQuery === element.quantityLocked;

export const mergeQueryLocked = (query, locked) => {
    const final = query.map(item => {
        const found = Object.values(locked).find(
            lockedItem => item.facialValue === lockedItem.facialValue
        );
        return {
            ...found,
            hasQuantity: queryEqualLocked(found),
            name: item.name
        };
    });

    return final;
};

export function compare(a, b) {
    if (a.facialValue < b.facialValue) {
        return -1;
    }
    if (a.facialValue > b.facialValue) {
        return 1;
    }
    return 0;
}

export const getCashbackAmount = ebons => {
    const {
        ebonDiscount = { cashback: { fixed: 0, percent: 0 }, parity: { fixed: 0, percent: 0 } }
    } = ebons;
    const effectiveDiscount = USE_PARITY ? ebonDiscount.parity : ebonDiscount.cashback;
    const fixed = effectiveDiscount.fixed.value;
    const percent = effectiveDiscount.percent.value;

    return fixed > 0 ? fixed : percent;
};



// WEBPACK FOOTER //
// ./src/utils/ebonUtils.js